import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        '\n  display: flex;\n  align-items: center;\n  svg {\n    transition: transform 0.3s;\n  }\n  :hover {\n    svg {\n      transform: scale(1.2);\n    }\n  }\n\n  span {\n    font-family: "Space Grotesk";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: #f6b24f;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Skeleton from "../Skeleton/Skeleton";
import { SVCLogo } from "../Svg";
var PriceLink = styled.a.withConfig({
    componentId: "sc-6db6babc-0"
})(_templateObject());
var CakePrice = function(param) {
    var svcBalance = param.svcBalance, _showSkeleton = param.showSkeleton, showSkeleton = _showSkeleton === void 0 ? true : _showSkeleton;
    var balanceFormatted = svcBalance ? Number(svcBalance).toFixed(3).replace(/\d(?=(\d{3})+\.)/g, "$&,") : 0;
    return svcBalance ? /*#__PURE__*/ _jsxs(PriceLink, {
        href: "#",
        children: [
            /*#__PURE__*/ _jsx(SVCLogo, {
                width: "24px",
                mr: "8px"
            }),
            /*#__PURE__*/ _jsx("span", {
                children: balanceFormatted
            })
        ]
    }) : showSkeleton ? /*#__PURE__*/ _jsx(Skeleton, {
        width: 80,
        height: 24
    }) : null;
};
export default /*#__PURE__*/ React.memo(CakePrice);
